var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStagevergoedingGesloten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 279.27 266.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #707e80;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #dbdbdb;\n      }\n\n      .cls-4 {\n        fill: #37474f;\n      }\n\n      .cls-5 {\n        fill: #455a64;\n      }\n\n      .cls-6 {\n        fill: #b1b1b1;\n        opacity: .62;\n      }\n\n      .cls-7 {\n        fill: #767676;\n      }\n\n      .cls-8 {\n        fill: #ffc727;\n      }\n\n      .cls-9 {\n        fill: #263238;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n        filter: url(#drop-shadow-1);\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 266.25,
    y1: 68.62,
    x2: 223.35,
    y2: 59.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d9d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c4c4c4"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-1--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 4.26,
    y: 25,
    width: 270.73,
    height: 241.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.26,
    y: 25,
    width: 270.73,
    height: 89.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 22.64,
    y: 235.52,
    width: 13.36,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.18,
    y: 242.63,
    width: 13.36,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.09,
    y: 242.63,
    width: 13.36,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.26,
    y: 242.63,
    width: 13.36,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.26,
    y: 152.61,
    width: 13.36,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.73,
    y: 159.74,
    width: 13.36,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.18,
    y: 152.63,
    width: 13.36,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 138.32,
    y: 189.3,
    width: 13.36,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 145.77,
    y: 182.19,
    width: 13.36,
    height: 5.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.08,
    y: 43.87,
    width: 36.19,
    height: 55.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 28.04,
    y: 46.82,
    width: 30.3,
    height: 49.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.33 46.82 58.33 52.79 28.04 83.09 28.04 68.73 49.95 46.82 58.33 46.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.33 78.13 58.33 92.47 54.47 96.34 40.12 96.34 58.33 78.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.33 71.83 58.33 74.86 36.85 96.34 33.83 96.34 58.33 71.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "46.9 46.82 28.04 65.67 28.04 59.74 40.97 46.82 46.9 46.82"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.04,
    y: 61.01,
    width: 30.3,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 75.55,
    y: 43.87,
    width: 36.19,
    height: 55.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 78.49,
    y: 46.82,
    width: 30.3,
    height: 49.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "108.79 46.82 108.79 52.79 78.49 83.09 78.49 68.73 100.42 46.82 108.79 46.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "108.79 78.13 108.79 92.47 104.93 96.34 90.58 96.34 108.79 78.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "108.79 71.83 108.79 74.86 87.32 96.34 84.29 96.34 108.79 71.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97.36 46.82 78.49 65.67 78.49 59.74 91.43 46.82 97.36 46.82"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.49,
    y: 61.01,
    width: 30.3,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 163.2,
    y: 43.87,
    width: 36.19,
    height: 55.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 166.14,
    y: 46.82,
    width: 30.3,
    height: 49.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196.45 46.82 196.45 52.79 166.14 83.09 166.14 68.73 188.05 46.82 196.45 46.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196.45 78.13 196.45 92.47 192.57 96.34 178.22 96.34 196.45 78.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "196.45 71.83 196.45 74.86 174.95 96.34 171.93 96.34 196.45 71.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "185.01 46.82 166.14 65.67 166.14 59.74 179.07 46.82 185.01 46.82"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 166.14,
    y: 61.01,
    width: 30.3,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 213.66,
    y: 43.87,
    width: 36.19,
    height: 55.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 216.61,
    y: 46.82,
    width: 30.3,
    height: 49.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "246.91 46.82 246.91 52.79 216.61 83.09 216.61 68.73 238.52 46.82 246.91 46.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "246.91 78.13 246.91 92.47 243.03 96.34 228.68 96.34 246.91 78.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "246.91 71.83 246.91 74.86 225.42 96.34 222.39 96.34 246.91 71.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "235.46 46.82 216.61 65.67 216.61 59.74 229.53 46.82 235.46 46.82"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 216.61,
    y: 61.01,
    width: 30.3,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0,
    y: 261.26,
    width: 279.27,
    height: 5.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 0,
    y: 25.04,
    width: 279.27,
    height: 5.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 157.04,
    y: 161.17,
    width: 46.04,
    height: 105.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 164.91,
    y: 169.03,
    width: 30.3,
    height: 49.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "195.19 169.03 195.19 175.01 164.89 205.31 164.89 190.96 186.82 169.03 195.19 169.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "195.19 200.35 195.19 214.7 191.33 218.56 176.98 218.56 195.19 200.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "195.19 194.05 195.19 197.08 173.72 218.56 170.69 218.56 195.19 194.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "183.76 169.03 164.89 187.9 164.89 181.96 177.83 169.03 183.76 169.03"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 197.24,
    y: 223.26,
    width: 2.78,
    height: 12.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 203.84,
    y: 161.17,
    width: 46.04,
    height: 105.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.71,
    y: 169.03,
    width: 30.3,
    height: 49.52
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "242.01 169.03 242.01 175.01 211.71 205.31 211.71 190.96 233.63 169.03 242.01 169.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "242.01 200.35 242.01 214.7 238.14 218.56 223.79 218.56 242.01 200.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "242.01 194.05 242.01 197.08 220.53 218.56 217.51 218.56 242.01 194.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "230.58 169.03 211.71 187.9 211.71 181.96 224.64 169.03 230.58 169.03"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 206.88,
    y: 223.26,
    width: 2.78,
    height: 12.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.78,
    width: 235.7,
    height: 25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 27.98,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 39.5,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 51.03,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 62.55,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 74.08,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 85.61,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 97.12,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 108.65,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 120.17,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 131.7,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 143.23,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 154.75,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 166.28,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177.8,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 189.33,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 200.86,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 212.38,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 223.91,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 235.44,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 246.95,
    y: 4.48,
    width: 4.33,
    height: 16.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m76.23,186.75v43.68H25.12v-43.68c0-14.11,11.44-25.55,25.55-25.55s25.55,11.44,25.55,25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.29,186.75v40.74H28.04v-40.74c0-12.49,10.13-22.62,22.62-22.62s22.62,10.13,22.62,22.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m73.3,186.75v40.74H28.04v-40.74c-.02-12.48,10.08-22.61,22.56-22.64.02,0,.04,0,.07,0,.73,0,1.44,0,2.14.11,7.14.68,13.54,4.7,17.24,10.85.81,1.32,1.47,2.73,1.98,4.2.3.81.54,1.63.71,2.47.38,1.64.57,3.32.56,5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.05,175.07l-42,41.99v-15.04l34.53-34.53c3.06,1.89,5.63,4.49,7.48,7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m72.74,181.74l-44.69,44.69v-3.19l43.98-43.98c.3.81.54,1.63.71,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.84,164.22l-24.8,24.76v-2.23c0-1.49.14-2.97.43-4.42l17.78-17.78c1.45-.29,2.93-.43,4.41-.43.73,0,1.44.04,2.18.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m139.22,186.75v43.68h-51.11v-43.68c0-14.11,11.44-25.55,25.55-25.55s25.55,11.44,25.55,25.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m136.23,186.75v40.74h-45.22v-40.74c-.3-12.5,9.58-22.88,22.08-23.18,12.5-.3,22.88,9.58,23.18,22.08,0,.37,0,.74,0,1.1h-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m136.23,186.75v40.74h-45.22v-40.74c-.02-12.48,10.08-22.61,22.56-22.64.02,0,.04,0,.07,0,.73,0,1.44,0,2.14.11,7.14.68,13.54,4.7,17.24,10.85.81,1.32,1.47,2.73,1.98,4.2.3.81.54,1.63.71,2.47.37,1.64.54,3.32.52,5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m133.02,175.07l-42,41.99v-15.04l34.53-34.53c3.06,1.89,5.63,4.49,7.48,7.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.71,181.74l-44.69,44.69v-3.19l43.98-43.98c.3.81.54,1.63.71,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.77,164.22l-24.76,24.76v-2.23c0-1.49.14-2.97.43-4.42l17.78-17.78c1.45-.29,2.93-.43,4.41-.43.73,0,1.44.04,2.14.11Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 4.26,
    y: 114.39,
    width: 270.15,
    height: 32.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.26,
    y: 141.14,
    width: 270.15,
    height: 0.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.26,
    y: 119.55,
    width: 270.15,
    height: 0.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m61.32,127.86c-.24-.54-.89-.88-1.82-.88-1.12,0-1.83.37-1.83,1.04,0,.83,1.88,1.25,3.48,1.69,2.27.63,3.68,1.56,3.7,3.35,0,2.25-1.77,3.73-5.19,3.73-2.71,0-4.56-1.13-5.17-2.82-.17-.38-.26-.79-.26-1.21h3.31c0,.21.04.41.12.58.25.6.99.99,2.04.99,1.1,0,1.82-.43,1.82-1.13,0-.96-1.87-1.29-3.41-1.7-2.1-.55-3.65-1.59-3.65-3.23,0-2.29,1.99-3.59,5.25-3.59,2.5,0,4.23,1.04,4.78,2.62.13.36.2.75.19,1.16h-3.23c0-.23-.05-.43-.14-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m75.13,127.47h-3.15v9.11h-3.3v-9.11h-3.16v-2.58h9.61v2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m83.2,136.58l-.64-2.14h-4.09l-.64,2.14h-3.41l3.88-11.69h4.39l3.9,11.69h-3.39Zm-1.34-4.45l-1.35-4.5-1.35,4.5h2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m92.52,127.27c-1.58,0-2.56,1.14-2.56,3.46s.99,3.46,2.56,3.46c1.31,0,2.22-.84,2.42-2.32h-2.81v-2.04h6.18v6.75h-2.31l-.13-1.95c-.59,1.4-1.77,2.16-3.82,2.16-3.11,0-5.38-2.01-5.38-6.05s2.28-6.05,5.86-6.05c3,0,5.19,1.4,5.65,4.22h-3.39c-.28-1.04-1.15-1.63-2.26-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m103.37,127.47v2.14h4.97v2.25h-4.97v2.15h5.88v2.58h-9.17v-11.69h9.17v2.58h-5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m118.37,136.58h-4.2l-3.78-11.69h3.52l2.38,8.66,2.37-8.66h3.51l-3.81,11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m126.6,127.47v2.14h4.97v2.25h-4.97v2.15h5.88v2.58h-9.17v-11.69h9.17v2.58h-5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m144.71,128.88c0,1.66-.73,2.96-2.03,3.61l2.44,4.08h-3.46l-2.04-3.64h-2.09v3.64h-3.3v-11.69h6.4c2.53,0,4.07,1.65,4.07,3.99Zm-4.8,1.67c.94,0,1.5-.56,1.5-1.61s-.57-1.6-1.5-1.6h-2.38v3.21h2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m151.58,127.27c-1.58,0-2.56,1.14-2.56,3.46s.99,3.46,2.56,3.46c1.31,0,2.22-.84,2.42-2.32h-2.81v-2.04h6.18v6.75h-2.31l-.13-1.95c-.59,1.4-1.77,2.16-3.82,2.16-3.11,0-5.38-2.01-5.38-6.05s2.28-6.05,5.86-6.05c3,0,5.19,1.4,5.65,4.22h-3.39c-.28-1.04-1.15-1.63-2.26-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m158.79,130.73c0-4.04,2.28-6.05,5.85-6.05s5.87,2.01,5.87,6.05-2.29,6.05-5.87,6.05-5.85-2.01-5.85-6.05Zm5.85,3.46c1.58,0,2.57-1.11,2.57-3.46s-.99-3.46-2.57-3.46-2.55,1.11-2.55,3.46.99,3.46,2.55,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m175.19,127.47v2.14h4.97v2.25h-4.97v2.15h5.88v2.58h-9.17v-11.69h9.17v2.58h-5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m194.02,130.75c0,3.84-2.35,5.83-5.93,5.83h-5.27v-11.69h5.27c3.57,0,5.93,2.02,5.93,5.86Zm-5.93,3.37c1.59,0,2.63-1.08,2.63-3.37s-1.03-3.41-2.63-3.41h-1.98v6.78h1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m198.71,136.58h-3.3v-11.69h3.3v11.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m211.69,124.89v11.69h-3.52l-4.19-6.52v6.52h-3.3v-11.69h3.52l4.19,6.53v-6.53h3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m218.96,127.27c-1.58,0-2.56,1.14-2.56,3.46s.99,3.46,2.56,3.46c1.31,0,2.22-.84,2.42-2.32h-2.81v-2.04h6.18v6.75h-2.31l-.13-1.95c-.59,1.4-1.77,2.16-3.82,2.16-3.11,0-5.38-2.01-5.38-6.05s2.28-6.05,5.86-6.05c3,0,5.19,1.4,5.65,4.22h-3.39c-.28-1.04-1.15-1.63-2.26-1.63Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 91.01,
    y: 186.33,
    width: 45.26,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 103.93,
    y: 163.18,
    width: 2.95,
    height: 23.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 120.4,
    y: 163.2,
    width: 2.95,
    height: 23.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.04,
    y: 186.33,
    width: 45.26,
    height: 2.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40.95,
    y: 163.2,
    width: 2.95,
    height: 23.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 57.42,
    y: 163.2,
    width: 2.95,
    height: 23.15
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "274.99 30.67 279.27 30.67 279.27 25.04 274.99 25.04 274.99 25 257.48 25 257.48 0 21.77 0 21.77 25 4.26 25 4.26 25.04 0 25.04 0 30.67 4.26 30.67 4.26 114.39 4.26 119.55 4.26 120.23 4.26 141.14 4.26 141.81 4.26 146.96 4.26 261.26 0 261.26 0 266.88 4.26 266.88 4.26 266.89 274.99 266.89 274.99 266.88 279.27 266.88 279.27 261.26 274.99 261.26 274.99 114.39 274.99 30.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m264.09,57.38l.4-2.58c.1-.71.16-1.41.19-2.11l.05-.49h-.05c.11-9.03-6.37-16.87-15.49-18.28-9.11-1.41-17.66,4.1-20.27,12.74h-.04s-.1.47-.1.47c-.2.68-.36,1.37-.46,2.08l-.4,2.58c-2.86-.44-5.53,1.53-5.97,4.37l-4.39,28.43c-.44,2.84,1.52,5.52,4.37,5.96l36.18,5.59c2.86.45,5.52-1.53,5.96-4.36l4.39-28.43c.44-2.85-1.52-5.52-4.36-5.97Zm-15.08,16.78c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Zm7.72-20.56l-.4,2.58-20.67-3.19.4-2.58c.1-.72.32-1.41.58-2.06.35-.93.83-1.77,1.39-2.54.18-.23.33-.46.53-.68.19-.22.4-.42.62-.64.26-.24.51-.48.8-.69.19-.16.4-.29.61-.43.33-.24.68-.45,1.05-.64.2-.09.4-.2.6-.29.4-.18.82-.31,1.23-.44.2-.05.39-.13.59-.18.45-.09.91-.15,1.38-.2.19-.02.38-.05.56-.06.66-.03,1.34,0,2.01.1.71.1,1.4.29,2.05.53,3.25,1.2,5.67,3.97,6.51,7.27.16.65.26,1.32.3,2.01.02.69-.01,1.41-.13,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m249.01,74.16c-.3,1.21-1.51,2.62-4.01,3.6-.27.11-.46.38-.45.68.17,2.73.26,4.6-.09,7.3-.05.37-.41.63-.78.58l-5.41-.84c-.38-.06-.63-.42-.58-.78.47-2.69,1.07-4.47,2.04-7.04.09-.26.03-.56-.18-.75-1.88-1.73-2.51-3.35-2.35-4.56.94-7.17,13.5-5.06,11.81,1.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStagevergoedingGesloten);
export default __webpack_public_path__ + "static/media/stagevergoeding-gesloten.1fde7b28a1974c6cd0c0f5f6f3e3cf5b.svg";
export { ForwardRef as ReactComponent };